import { communityReportReason } from '@src/models/communityReportReason';

export const communityReportReasonLabel: Record<communityReportReason, string> = {
  [communityReportReason.INSULT]: '모욕적인 내용',
  [communityReportReason.NAKED]: '선정적인 내용',
  [communityReportReason.SPOILER]: '스포일러',
  [communityReportReason.ETC]: '기타'
};
